import { render, staticRenderFns } from "./StoreItem.vue?vue&type=template&id=2b143754&scoped=true"
import script from "./StoreItem.vue?vue&type=script&lang=js"
export * from "./StoreItem.vue?vue&type=script&lang=js"
import style0 from "./StoreItem.vue?vue&type=style&index=0&id=2b143754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b143754",
  null
  
)

export default component.exports